<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    :type="modalType"
    class="EditFeedSource"
    title="Edit Feed Source"
    submit-name="Save changes"
    :submit-disabled="!source"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <template v-if="source">
      <div v-show="showSource" class="flex items-end flex-nowrap mb-8">
        <lm-input
          ref="inputURL"
          v-tooltip="warningMessage"
          class="w-full mx-2 mb0-important"
          label="URL"
          :maxlength="0"
          disabled
        />
        <lm-icon-button
          icon="open_in_new"
          tooltip="Open source"
          @click="openLink"
        />
      </div>
      <lm-input ref="inputTitle" label="Name" focus @submit="submitFromInput" />
      <lm-textarea
        ref="inputDescription"
        label="Description (optional)"
        :allow-breakline="false"
        @submit="submitFromInput()"
      />
      <lm-tags-selector
        ref="tagSelector"
        :options="currentLandscape.tags"
        :tags="tags"
        :required="requiredTagsFeedSource"
      />
    </template>
  </form-modal>
</template>

<script>
import LmIconButton from '@/components/ui/LmIconButton'
import {mapGetters} from 'vuex'
import {
  Events,
  Modal,
  ModalType,
  AlertMessages,
  FeedSources
} from '@/lib/definitions'
import FormModal from '@/components/modals/FormModal'
import LmInput from '@/components/form/LmInput.vue'
import LmTextarea from '@/components/form/LmTextarea.vue'
import FormHelper from '@/components/form/formHelper'
import LmTagsSelector from '@/components/form/LmTagsSelector'

export default {
  components: {
    LmIconButton,
    LmTagsSelector,
    FormModal,
    LmTextarea,
    LmInput
  },
  data() {
    return {
      Events,
      FeedSources,
      modalName: Modal.EDIT_FEED_SOURCE,
      modalType: ModalType.EDIT_FEED_SOURCE,
      modalRef: null,
      inputs: null,
      source: null,
      tags: []
    }
  },
  computed: {
    ...mapGetters([
      'selectedActor',
      'currentLandscape',
      'getLandscapeSourceById'
    ]),
    ...mapGetters({
      requiredTagsFeedSource: 'preferences/requiredTagsFeedSource'
    }),
    showSource() {
      if (!this.source) return false
      const type = this.source.type
      return (
        this.source &&
        type !== FeedSources.CHANNEL &&
        type !== FeedSources.ACCESO
      )
    },
    warningMessage() {
      return 'It is not possible to change the url.<br>If this Source is not valid anymore, please delete it and create a new one.'
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [
      this.$refs.inputTitle,
      this.$refs.inputDescription,
      this.$refs.tagSelector
    ]
    this.loadData()
  },
  methods: {
    openLink() {
      window.open(this.source.url, '_blank')
    },
    loadData() {
      if (this.$route.query.editFeedSource) {
        this.source = this.getLandscapeSourceById(
          this.$route.query.editFeedSource
        )
      }
      if (this.source) {
        this.$nextTick(() => {
          this.$refs.inputURL.setData(this.source.url)
          this.$refs.inputTitle.setData(this.source.title)
          this.$refs.inputDescription.setData(this.source.description)
          if (Array.isArray(this.source.tags)) {
            this.tags = this.source.tags.slice()
          }
          this.inputs = [
            this.$refs.inputTitle,
            this.$refs.inputDescription,
            this.$refs.tagSelector
          ]
        })
      }
    },
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        let payload = {
          pipeRef: this.source.pipeRef,
          title: this.$refs.inputTitle.data,
          description: this.$refs.inputDescription.data,
          tags: this.$refs.tagSelector.data,
          source: this.source
        }
        this.$store
          .dispatch('editSource', payload)
          .then(() => this.modalRef.submitSuccess())
          .catch(error => {
            if (error.devCode === 404) {
              this.modalRef.submitFails(AlertMessages.RSS_URL_ERROR)
            } else {
              this.modalRef.submitFails(error)
            }
          })
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed() {}
  }
}
</script>

<style scoped>
.EditFeedSource {
  .LmTagsSelector {
    margin-bottom: 30px;
  }
}
</style>
